import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/pa2.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import AppRouter from './AppRouter';

// Force naked domain to redirect to www before any API calls are made.
// Reason: Azure SWA does a 301 redirect from physioactivity.com -> www.physioactivity.com,
// and HTTP clients commonly strip the body and convert POST to GET on 301 redirects,
// breaking every transactional API endpoint.
if (typeof window !== 'undefined' && window.location.hostname === 'physioactivity.com') {
    window.location.replace('https://www.physioactivity.com' + window.location.pathname + window.location.search + window.location.hash);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AppRouter />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
